import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { ModificationsFeatureConfig } from '../../../types/features/ModificationsFeatureConfig';
import { modifications as base } from './base';
import { modifications as AT } from './AT';
import { modifications as CZ } from './CZ';
import { modifications as HR } from './HR';
import { modifications as HU } from './HU';
import { modifications as RO } from './RO';
import { modifications as RS } from './RS';
import { modifications as SK } from './SK';

export const modificationsConfig: InsuranceIndex<ModificationsFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    RS,
    SK,
};
